import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export function Eyebrow({ children, className = '' }) {
  return <span className={`eyebrow ${className}`}>{children}</span>;
}

export function SectionHeader({ eyebrow, title, italic, kicker, align = 'left' }) {
  const alignCls = align === 'center' ? 'text-center mx-auto items-center' : 'text-left items-start';
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl gap-5`}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-[#1C1C1C]">
        {title}
        {italic && (
          <>
            <br /><span className="font-serif-italic italic text-[#C9A24D]">{italic}</span>
          </>
        )}
      </h2>
      {kicker && <p className="text-base sm:text-lg text-[#1C1C1C]/70 max-w-2xl leading-relaxed">{kicker}</p>}
    </div>
  );
}

export function TextLink({ to, children, testid }) {
  return (
    <Link to={to} data-testid={testid} className="inline-flex items-center gap-2 text-sm tracking-[0.12em] uppercase font-medium text-[#1C1C1C] gold-underline">
      {children}
      <ArrowRight size={14} />
    </Link>
  );
}
